import { useTranslation } from 'react-i18next';
import Alert from './Alert';
import { useAlertStore } from './AlertStore';
import { useCallback } from 'react';

export const useNotifyMap = () => {
  const { showMapAlert, hideAlert } = useAlertStore();
  const { t } = useTranslation();

  const notifyMap = useCallback(
    (messageKey: string) => {
      showMapAlert({
        mapPortalContent: <Alert message={t(messageKey)} onClose={hideAlert} />,
      });
    },
    [showMapAlert, hideAlert, t]
  );

  return notifyMap;
};
